import { buildCloudFrontUrl } from '@/utils/pathUtils';
import fontManagerService from '@/utils/fontManagerService';

(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('EditLibraryCtrl', librariesCtrl);

    function librariesCtrl(
        $scope,
        $rootScope,
        LibrariesAPIService,
        FontManagerService,
        $location,
        $timeout,
        $mdDialog,
        blockUI
    ) {
        $scope.colorModeStrings = ['RGB', 'CMYK'];
        $scope.libraryTypeStrings = ['Color', 'Font', 'Vector', 'Image'];

        $scope.filteredElements = [];
        $scope.currentPage = 1;
        $scope.numPerPage = 10;
        $scope.maxSize = 10;
        $scope.elementsCount = 0;
        $scope.searchString = '';
        $scope.libraryType = 'color';
        $scope.library = null;
        $scope.categoryId = null;
        $scope.addElementLoading = false;
        $scope.addCategoryLoading = false;
        $scope.currentNavItem = '';
        $scope.showModalSortUpdate = false;
        $scope.sortUpdateModalProps = {};
        $scope.isSyncing = false;
        $scope._intervalSync = null;

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        $scope.$watch('currentPage + numPerPage', function () {
            $scope.begin = ($scope.currentPage - 1) * $scope.numPerPage;
            $scope.getList();
        });

        $scope.goToLibraries = function () {
            $location.path('/libraries').search({});
        };

        $scope.goToCategories = function () {
            $location.path('/editLibrary').search({
                id: $scope.library.LibraryId
            });
        };

        $scope.getThumbUrl = function (thumbPath) {
            if (thumbPath) {
                return buildCloudFrontUrl(thumbPath, true);
            }
            return '';
        };

        $scope.getList = async function () {
            $scope.library = $scope.library || (await LibrariesAPIService.getLibrary($location.search().id));
            $scope.libraryType = $scope.libraryTypeStrings[$scope.library.Type];
            if ($location.search().categoryId) {
                $scope.categoryId = $location.search().categoryId;
                var category = await LibrariesAPIService.getCategory($scope.library.LibraryId, $scope.categoryId);
                $rootScope.headerTitle =
                    $scope.library.Name +
                    ' - ' +
                    category.Name +
                    ' — ' +
                    capitalizeFirstLetter($scope.libraryType) +
                    ' Library';
                $scope.getElementsByCategory();
            } else {
                // Set proper header title
                $rootScope.headerTitle =
                    $scope.library.Name + ' — ' + capitalizeFirstLetter($scope.libraryType) + ' Library';

                if ($scope.currentNavItem === '') {
                    var categoryCount = await LibrariesAPIService.getLibraryCategoriesCount($scope.library.LibraryId);
                    if (categoryCount > 0) {
                        $scope.currentNavItem = 'category';
                    } else {
                        var elementCount = await LibrariesAPIService.getLibraryElementsCount($scope.library.LibraryId);
                        if (elementCount > 0) {
                            $scope.currentNavItem = 'library';
                        }
                    }
                }

                if ($scope.currentNavItem === 'category') {
                    $scope.getCategories();
                } else if ($scope.currentNavItem === 'library') {
                    $scope.getElements();
                }
            }
            $scope._stopIntervalSync();
            $scope._checkSync();
        };

        $scope.getElements = function () {
            blockUI.start('Loading elements');
            console.log('Getting library elements');

            var promises = [];

            // If this is a fonts library, load the user fonts
            if ($scope.libraryType.toLowerCase() === 'font') {
                console.log('Loading fonts');
                promises.push(FontManagerService.getAllFonts());
            }

            // Load all the elements from this library
            LibrariesAPIService.getLibraryElements(
                $scope.searchString,
                $scope.begin,
                $scope.numPerPage,
                $scope.library.LibraryId
            )
                .then(function (elements) {
                    // Because the search string only filters by option and they are unique the total element count can be 1 or 0
                    if ($scope.searchString) {
                        $scope.elementsCount = $scope.filteredElements.length;
                        $scope.filteredElements = elements;
                        blockUI.stop();
                    } else {
                        LibrariesAPIService.getLibraryElementsCount($scope.library.LibraryId)
                            .then(function (count) {
                                $scope.elementsCount = count;
                                if (!count) {
                                    $scope.currentNavItem = '';
                                }
                                Promise.all(promises)
                                    .then(function () {
                                        // Assign the elements at the end so the template is refreshed now that we have all the data
                                        $scope.filteredElements = elements;
                                        blockUI.stop();
                                        $timeout(function () {
                                            $scope.$apply();
                                        });
                                    })
                                    .catch(function (error) {
                                        window.rumReportError(error);
                                        blockUI.stop();
                                    });
                            })
                            .catch(function (error) {
                                window.rumReportError(error);
                                blockUI.stop();
                            });
                    }
                })
                .catch(function (error) {
                    window.rumReportError(error);
                    blockUI.stop();
                });
        };

        $scope.getElementsByCategory = function () {
            blockUI.start('Loading elements');
            console.log('Getting category elements');

            LibrariesAPIService.getElementsByCategory(
                $scope.searchString,
                $scope.begin,
                $scope.numPerPage,
                $scope.library.LibraryId,
                $scope.categoryId
            )
                .then(function (elements) {
                    // Because the search string only filters by option and they are unique the total element count can be 1 or 0
                    if ($scope.searchString) {
                        $scope.elementsCount = $scope.filteredElements.length;
                        $scope.filteredElements = elements;
                        blockUI.stop();
                    } else {
                        LibrariesAPIService.getElementsByCategoryCount($scope.library.LibraryId, $scope.categoryId)
                            .then(function (count) {
                                $scope.elementsCount = count;
                                $scope.filteredElements = elements;
                                blockUI.stop();
                                $timeout(function () {
                                    $scope.$apply();
                                });
                            })
                            .catch(function (error) {
                                window.rumReportError(error);
                                blockUI.stop();
                            });
                    }
                })
                .catch(function (error) {
                    window.rumReportError(error);
                    blockUI.stop();
                });
        };

        $scope.getCategories = function () {
            blockUI.start('Loading categories');
            console.log('Getting library categories');
            // Load all the categories from this library
            LibrariesAPIService.getLibraryCategories(
                $scope.searchString,
                $scope.begin,
                $scope.numPerPage,
                $scope.library.LibraryId
            )
                .then(function (elements) {
                    // Because the search string only filters by option and they are unique the total element count can be 1 or 0
                    if ($scope.searchString) {
                        $scope.elementsCount = $scope.filteredElements.length;
                        $scope.filteredElements = elements;
                        blockUI.stop();
                    } else {
                        LibrariesAPIService.getLibraryCategoriesCount($scope.library.LibraryId)
                            .then(function (count) {
                                $scope.elementsCount = count;
                                $scope.filteredElements = elements;
                                if (!count) {
                                    $scope.currentNavItem = '';
                                }
                                blockUI.stop();
                                $timeout(function () {
                                    $scope.$apply();
                                });
                            })
                            .catch(function (e) {
                                console.error(e);
                                blockUI.stop();
                            });
                    }
                })
                .catch(function (e) {
                    console.error(e);
                    blockUI.stop();
                });
        };

        $scope.addElement = async function (localsOverride) {
            $scope.addElementLoading = true;
            var elementsCount = await LibrariesAPIService.getLibraryElementsLastPosition($scope.library.LibraryId);
            var elementsSort = await LibrariesAPIService.getLibraryElementsLastSort(
                $scope.library.LibraryId,
                $scope.categoryId || null
            );

            // Index 0 in the array is the dialog for library type 0 (Color) and so on
            var dialogsForType = [
                {
                    controller: 'ColorDialogCtrl',
                    template: require('../../../../views/pages/libraries/dialogs/color/color.html'),
                    locals: Object.assign(
                        {
                            colorMode: $scope.colorModeStrings[$scope.library.ColorMode],
                            library: $scope.library,
                            element: null,
                            initialPosition: elementsCount + 1,
                            initialSort: elementsSort + 1
                        },
                        localsOverride
                    )
                },
                {
                    controller: 'FontDialogCtrl',
                    template: require('../../../../views/pages/libraries/dialogs/font/font.html'),
                    locals: Object.assign(
                        {
                            library: $scope.library,
                            element: null,
                            initialPosition: elementsCount + 1,
                            initialSort: elementsSort + 1
                        },
                        localsOverride
                    )
                },
                {
                    controller: 'VectorDialogCtrl',
                    template: require('../../../../views/pages/libraries/dialogs/vector/vector.html'),
                    locals: Object.assign(
                        {
                            library: $scope.library,
                            element: null,
                            initialPosition: elementsCount + 1,
                            initialSort: elementsSort + 1
                        },
                        localsOverride
                    )
                },
                {
                    controller: 'ImageDialogCtrl',
                    template: require('../../../../views/pages/libraries/dialogs/image/image.html'),
                    locals: Object.assign(
                        {
                            library: $scope.library,
                            element: null,
                            initialPosition: elementsCount + 1,
                            initialSort: elementsSort + 1
                        },
                        localsOverride
                    )
                }
            ];

            $mdDialog
                .show({
                    controller: dialogsForType[$scope.library.Type].controller,
                    template: dialogsForType[$scope.library.Type].template,
                    locals: dialogsForType[$scope.library.Type].locals,
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    onComplete: function () {
                        $scope.addElementLoading = false;
                    }
                })
                .then(
                    function () {
                        $scope.currentNavItem = 'library';
                        // New element added, refresh the list
                        $scope.getList();
                    },
                    function () {
                        //
                    }
                );
        };

        $scope.addCategory = async function (localsOverride, thumbnailOnly = false) {
            $scope.addCategoryLoading = true;

            $mdDialog
                .show({
                    controller: 'CategoryDialogCtrl',
                    template: require('../../../../views/pages/libraries/dialogs/category/category.html'),
                    locals: Object.assign(
                        {
                            library: $scope.library,
                            category: null,
                            thumbnailOnly: thumbnailOnly
                        },
                        localsOverride
                    ),
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    onComplete: function () {
                        $scope.addCategoryLoading = false;
                    }
                })
                .then(
                    function () {
                        $scope.currentNavItem = 'category';
                        // New category added, refresh the list
                        $scope.getCategories();
                    },
                    function () {
                        //
                    }
                );
        };

        $scope.delete = function (element) {
            var confirm = $mdDialog
                .confirm()
                .title(capitalizeFirstLetter($scope.libraryType) + ' deletion')
                .htmlContent(
                    'Are you sure you want to delete this ' +
                        $scope.libraryType.toLowerCase() +
                        ' at position <b>' +
                        element.position +
                        '</b>?<br>Deleting an element will make it to longer available to existing products.'
                )
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(
                function () {
                    // Delete the element
                    blockUI.start('Removing element');
                    LibrariesAPIService.deleteElement($scope.library.LibraryId, element.position).then(function () {
                        blockUI.stop();
                        $scope.getList();
                    });
                },
                function () {
                    // Do nothing
                }
            );
        };

        $scope.deleteCategory = function (category) {
            var confirm = $mdDialog
                .confirm()
                .title('Library category deletion')
                .htmlContent(
                    'Are you sure you want to delete category <b>' +
                        category.Name +
                        '</b>?<br>Deleting an element will make it to longer available to existing products.'
                )
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(
                function () {
                    // Delete the category
                    blockUI.start('Removing category');
                    LibrariesAPIService.deleteCategory($scope.library.LibraryId, category.CategoryId)
                        .then(function () {
                            blockUI.stop();
                            $scope.getCategories();
                        })
                        .catch((error) => {
                            blockUI.stop();
                            window.rumReportError(error);
                        });
                },
                function () {
                    // Do nothing
                }
            );
        };

        $scope.edit = function (element) {
            // Edit the given element
            $scope.addElement({
                element: element
            });
        };

        $scope.editCategory = function (category) {
            // Edit the given category
            $location.path('/editCategory').search({
                id: $scope.library.LibraryId,
                categoryId: category.CategoryId
            });
        };

        $scope.editLibrarySort = function (library, $event) {
            library.editingSort = true;
            library.prevSort = library.Sort;
            $timeout(() => {
                if ($event.currentTarget.nextElementSibling) $event.currentTarget.nextElementSibling.focus();
                else $event.currentTarget.focus();
            }, 300);
        };

        $scope.onEditingLibrarySortHandler = function (library) {
            library.editingSort = false;
            if (
                library.prevSort === library.Sort ||
                library.Sort === null ||
                library.Sort === '' ||
                isNaN(library.Sort) ||
                library.Sort <= 0
            ) {
                library.Sort = library.prevSort;
                return;
            }
            $scope.updateLibrarySort(library);
        };

        $scope.dragControlListeners = {
            orderChanged: function (event) {
                var source = event.source;
                var dest = event.dest;
                var diff = dest.index + 1 - (source.index + 1);
                var item = source.itemScope.item || {};
                if (source && item) {
                    if (diff < 0) {
                        item.Sort = item.Sort - Math.abs(diff);
                    } else {
                        item.Sort = item.Sort + Math.abs(diff);
                    }
                    let isCategory = $scope.currentNavItem === 'category';
                    if (isCategory) {
                        $scope.updateCategorySort(item);
                    } else {
                        $scope.updateLibrarySort(item);
                    }
                }
            }
        };

        $scope.cancelEditingLibrarySortHandler = function (library) {
            library.Sort = library.prevSort;
            delete library?.prevSort;
            library.editingSort = false;
        };

        $scope.editCategorySort = function (category, $event) {
            category.editingSort = true;
            category.prevSort = category.Sort;
            $timeout(() => {
                if ($event.currentTarget.nextElementSibling) $event.currentTarget.nextElementSibling.focus();
                else $event.currentTarget.focus();
            }, 300);
        };

        $scope.updateLibrarySort = function (library) {
            blockUI.start('Updating Library Sort');
            let type = $scope.libraryTypeStrings[$scope.library.Type];
            let elementId = '';
            switch (type.toLowerCase()) {
                case 'color':
                    elementId = 'ColorId';
                    break;
                case 'font':
                    elementId = 'FontId';
                    break;
                case 'vector':
                    elementId = 'VectorID';
                    break;
                case 'image':
                    elementId = 'ImageId';
                    break;
            }

            if (elementId && library && type) {
                LibrariesAPIService.updateElement($scope.library.LibraryId, library[elementId], library, type)
                    .then(function () {
                        blockUI.stop();
                        $scope.getList();
                    })
                    .catch(function (e) {
                        blockUI.stop();
                        console.error(e);
                    });
            } else {
                blockUI.stop();
            }
        };

        $scope.onEditingCategorySortHandler = function (category) {
            category.editingSort = false;
            if (
                category.prevSort === category.Sort ||
                category.Sort === null ||
                category.Sort === '' ||
                isNaN(category.Sort) ||
                category.Sort <= 0
            ) {
                category.Sort = category.prevSort;
                return;
            }
            $scope.updateCategorySort(category);
        };

        $scope.cancelEditingCategorySortHandler = function (category) {
            category.Sort = category.prevSort;
            delete category?.prevSort;
            category.editingSort = false;
        };

        $scope.updateCategorySort = function (category) {
            blockUI.start('Updating Category Sort');
            LibrariesAPIService.updateCategory($scope.library.LibraryId, category.CategoryId, {
                Name: category.Name,
                Path: category.Path,
                ThumbnailPath: category.ThumbnailPath,
                Sort: category.Sort
            })
                .then(function () {
                    blockUI.stop();
                    $scope.getCategories();
                })
                .catch(function (e) {
                    console.error(e);
                    blockUI.stop();
                });
        };

        $scope.toRgba = function (hex, alpha) {
            if (hex) {
                var converter = new Colors();
                var rgb = converter.convertColor(hex.replace('#', ''), 'HEX2RGB');
                return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + alpha + ')';
            }
            return '';
        };

        $scope.toStringCmyk = function (colorElement) {
            var components = colorElement.cmyk.split(',');
            return (
                'C: ' +
                (components[0] * 100).toFixed(0) +
                ', M: ' +
                (components[1] * 100).toFixed(0) +
                ', Y: ' +
                (components[2] * 100).toFixed(0) +
                ', K: ' +
                (components[3] * 100).toFixed(0)
            );
        };

        $scope.fontPathToName = function (fontPath) {
            var fonts = FontManagerService.getLoadedFonts();
            if (fonts && fontPath) {
                var font = fontManagerService.findFontByPath(fontPath);

                if (font) {
                    return font.Name + ' (' + font.Style + ')';
                }
            }
        };

        // Edit category name
        $scope.editCategoryName = function (category, $event) {
            category.editing = true;
            category.prevName = category.Name;
            $timeout(() => {
                if ($event.currentTarget.nextElementSibling) $event.currentTarget.nextElementSibling.focus();
                else $event.currentTarget.focus();
            }, 300);
        };

        // Edit category thumbnail
        $scope.editCategoryThumbnail = function (category) {
            // Edit the given category
            $scope.addCategory({
                category: category,
                thumbnailOnly: true
            });
        };

        $scope.doneEditing = function (category) {
            category.editing = false;
            if (category.prevName === category.Name) return;

            blockUI.start('Saving name');

            if (category.Name === undefined || category.Name === null || category.Name.trim().length === 0) {
                category.Name = 'Category name';
            }

            LibrariesAPIService.updateCategory($scope.library.LibraryId, category.CategoryId, {
                Name: category.Name,
                Path: category.Path,
                ThumbnailPath: category.ThumbnailPath,
                Sort: category.Sort
            })
                .then(function () {
                    blockUI.stop();
                })
                .catch(function (e) {
                    console.error(e);
                    blockUI.stop();
                });
        };

        // Library name edit
        $scope.doBlur = function ($event) {
            var target = $event.target;
            target.blur();
        };

        $scope.editItem = function (library, $event) {
            library.editing = true;
            $timeout(() => {
                const target = $event.currentTarget;
                if (!target) return;
                const input = target.querySelector('input');
                if (input) input.focus();
            }, 300);
        };

        $scope.cancelEditItem = function (library) {
            library.editing = false;
        };

        $scope.updateLibraryName = (library, type) => {
            library.editing = false;
            if (type && library) {
                let elementId = '';

                switch (type.toLowerCase()) {
                    case 'color':
                        elementId = 'ColorId';
                        break;
                    case 'font':
                        elementId = 'FontId';
                        break;
                    case 'vector':
                        elementId = 'VectorID';
                        break;
                    case 'image':
                        elementId = 'ImageId';
                        break;
                }

                blockUI.start('Updating ' + type);
                LibrariesAPIService.updateElement($scope.library.LibraryId, library[elementId], library, type)
                    .then(function () {
                        blockUI.stop();
                    })
                    .catch(function (e) {
                        blockUI.stop();
                        console.error(e);
                    });
            }
        };

        $scope.sortLibraryAuto = function (typeSort) {
            blockUI.start('Sorting');
            let type = $scope.libraryTypeStrings[$scope.library.Type];
            let isCategory = $scope.currentNavItem === 'category';
            LibrariesAPIService.updateSort($scope.library.LibraryId, $scope.categoryId, type, typeSort, isCategory)
                .then(function () {
                    blockUI.stop();
                    if (isCategory) {
                        $scope.getCategories();
                    } else {
                        $scope.getList();
                    }
                })
                .catch(function (e) {
                    blockUI.stop();
                    window.rumReportError(e);
                });
        };

        //#region Sort
        $scope._checkSync = function () {
            const local = $scope._getLocalSorage();
            if (local && local.libraryId) {
                console.log('check sync', local.taskId);
                const now = Date.now();
                // clear local storage if time is more than 40 minutes
                const MAX_TIME = 40 * 60 * 1000;
                if (now - local.time > MAX_TIME) {
                    $scope._clearLocalSorage();
                    $scope.isSyncing = false;
                    $scope._stopIntervalSync();
                    console.warn('clear local storage sync');
                    return;
                }
                $scope.isSyncing = true;

                const promise = LibrariesAPIService.getTaskProgress(local.taskId, $scope.library.LibraryId);
                promise
                    .then(function (task) {
                        console.log('sync task', task);
                        if (task && (task.progress == 100 || task.error)) {
                            console.log('sync task done', task);
                            $scope._stopIntervalSync();
                            $timeout(function () {
                                $scope.isSyncing = false;
                                $scope._clearLocalSorage();
                            });
                            return;
                        }
                        if (!$scope._intervalSync) $scope._startIntervalSync();
                    })
                    .catch(function (e) {
                        console.error(e);
                        $scope.isSyncing = false;
                        $scope._clearLocalSorage();
                        $scope._stopIntervalSync();
                    });
            } else {
                $scope.isSyncing = false;
            }
        };

        $scope._stopIntervalSync = function () {
            if ($scope._intervalSync) clearInterval($scope._intervalSync);
            $scope._intervalSync = null;
        };

        $scope._startIntervalSync = function () {
            $scope._stopIntervalSync();
            console.warn('start interval sync');
            $scope._intervalSync = setInterval(function () {
                $scope._checkSync();
            }, 2000);
        };

        $scope._getLocalSorage = function () {
            let localKey = '';
            if ($scope.categoryId) {
                localKey = `librarySync-${$scope.library.LibraryId}-${$scope.categoryId}`;
            } else {
                localKey = `librarySync-${$scope.library.LibraryId}`;
            }
            return JSON.parse(localStorage.getItem(localKey) || '{}');
        };

        $scope._updateLocalSorage = function (updateData = null) {
            let localKey = '';
            if ($scope.categoryId) {
                localKey = `librarySync-${$scope.library.LibraryId}-${$scope.categoryId}`;
            } else {
                localKey = `librarySync-${$scope.library.LibraryId}`;
            }

            const local = $scope._getLocalSorage();
            if (local) {
                localStorage.removeItem(localKey);
            }
            let data = {
                libraryId: $scope.library.LibraryId,
                taskId: updateData ? updateData.taskId : '',
                categoryId: $scope.categoryId || '',
                time: Date.now()
            };
            if ($scope.currentNavItem === 'category') localStorage.setItem(localKey, JSON.stringify(data));
            else localStorage.setItem(localKey, JSON.stringify(data));
        };

        $scope._clearLocalSorage = function () {
            let localKey = '';
            if ($scope.categoryId) {
                localKey = `librarySync-${$scope.library.LibraryId}-${$scope.categoryId}`;
            } else {
                localKey = `librarySync-${$scope.library.LibraryId}`;
            }
            localStorage.removeItem(localKey);
        };
        //#endregion

        $scope._onSyncElements = function () {
            blockUI.start('Syncing elements');
            let isCategory = $scope.currentNavItem === 'category';
            LibrariesAPIService.syncSortElements($scope.library.LibraryId, $scope.categoryId, isCategory)
                .then(function (response) {
                    $timeout(function () {
                        $scope.isSyncing = true;
                        $scope._updateLocalSorage({
                            taskId: response?.progressIdentifier || ''
                        });
                        $scope._stopIntervalSync();
                        $scope._checkSync();
                        blockUI.stop();
                    });
                })
                .catch(function (e) {
                    blockUI.stop();
                    window.rumReportError(e);
                });
        };

        $scope.onSyncElements = function () {
            $scope.sortUpdateModalProps = {
                onConfirm: function () {
                    $scope._onSyncElements();
                    $timeout(function () {
                        $scope.showModalSortUpdate = false;
                    });
                },
                onCancel: function () {
                    $timeout(function () {
                        $scope.showModalSortUpdate = false;
                    });
                }
            };
            $scope.showModalSortUpdate = true;
        };

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        $rootScope.$on('$routeChangeSuccess', function (_event, _current) {
            $scope._stopIntervalSync();
        });
    }
})();
